import RadioButtonFilter from '../../../components/filter/RadioButtonFilter';
import { withSearch } from '@elastic/react-search-ui';

const COMMENTS_AND_PHOTOS_OPTIONS = [
  { value: undefined, label: 'All results' },
  { value: 'true', label: 'With comments or photos' },
  { value: 'false', label: 'No comments or photos' },
];

function NHLECommentsAndPhotosFilter({ setFilter, removeFilter, filters }) {
  return (
    <RadioButtonFilter
      fieldId="comments"
      filters={filters}
      id="comments-and-photos"
      label="Show results"
      options={COMMENTS_AND_PHOTOS_OPTIONS}
      removeFilter={removeFilter}
      setFilter={setFilter}
    />
  );
}

export default withSearch(({ setFilter, removeFilter, filters }) => ({
  setFilter,
  removeFilter,
  filters,
}))(NHLECommentsAndPhotosFilter);
